<template>
  <el-dialog
    :visible="visible"
    :title="isEdit?'编辑商品':'新增商品'"
    destroy-on-close
    :close-on-click-modal="false"
    append-to-body
    @close="onClose"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      label-position="left"
      :show-message="false"
    >
      <el-form-item
        label="SKU编码"
        prop="itemNo"
        required
      >
        <el-input
          v-model="form.itemNo"
          :maxlength="32"
          :disabled="!editSkuNo"
        />
      </el-form-item>
      <el-form-item v-if="!editSkuNo">
        <span style="color: red;"> {{ this.$t('CargoMsg.Cargo_CheckSavePoInfoItem') }}</span>
      </el-form-item>
      <el-form-item
        label="中文品名"
        prop="chineseCommodity"
      >
        <el-input v-model="form.chineseCommodity" />
      </el-form-item>
      <el-form-item
        label="英文品名"
        prop="englishCommodity"
        required
      >
        <el-input v-model="form.englishCommodity" />
      </el-form-item>
      <el-form-item
        label="MFG号"
        prop="mfg"
      >
        <el-input
          v-model="form.mfg"
          :maxlength="100"
        />
      </el-form-item>
      <el-form-item
        label="件数"
        required
        prop="quantity"
      >
        <el-input v-model="form.quantity" />
      </el-form-item>
      <el-form-item
        label="HS Code"
        prop="hsCode"
      >
        <el-input
          v-model="form.hsCode"
          :maxlength="20"
        />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      style="text-align:center"
    >
      <el-form>
        <span>
          <el-button
            type="primary"
            @click="onSave"
          >保存</el-button>
          <el-button @click="onClose">取消</el-button>
        </span>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { isPositiveInteger } from '@/utils/validate'
export default {
  name: 'GoodsForm',
  props: {
    visible: {
      type: Boolean,
      default: () => true
    },
    editSkuNo: { // 是否可以编辑skuNo,默认不可以，只有未关联包装的时候可以
      type: Boolean,
      default: () => false
    },
    item: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      curIndex: null,
      form: {
        itemNo: '',
        chineseCommodity: '',
        englishCommodity: '',
        mfg: '',
        quantity: '',
        hsCode: ''
      }
    }
  },
  computed: {
    isEdit() {
      return this.item || false
    }
  },
  watch: {
    item(val) {
      if (val) {
        Object.keys(this.form).forEach((key) => {
          if (val[key]) {
            this.form[key] = val[key]
          }
        })
      } else {
        this.form = {
          itemNo: '',
          chineseCommodity: '',
          englishCommodity: '',
          mfg: '',
          quantity: '',
          hsCode: ''
        }
      }
    }
  },
  methods: {
    onSave() {
      const data = { ...this.form }
      if (!data.itemNo.trim()) {
        this.$message.warning('SKU编码不能为空！')
        return
      }
      if (!data.englishCommodity.trim()) {
        this.$message.warning('英文品名不能为空！')
        return
      }
      console.log(!isPositiveInteger(data.quantity))
      if (!isPositiveInteger(data.quantity)) {
        this.$message.warning('件数应为大于0的整数')
        return
      }
      this.loading = getLoading()
      if (this.item) {
        data.uuid = this.item.uuid
        data.poItemUuid = this.item.poItemUuid
      }
      this.$emit('onSave', data)
    },
    onClose() {
      this.$refs.form.resetFields()
      this.$emit('onClose')
    }
  }
}
</script>
